import { usingGet, usingUpload, usingDelete, usingPost, createProxyUrl } from '@ocean/api'
import { SessionUtils } from '@ocean/utils'
import { UserUtils } from 'utils'
import {
  AssessStatus,
  SelfAssessmentParams,
} from 'modules/activityDetails/SelfAssessmentDetails/types'

export const getSelfAssessmentDetails = (assessmentId: Guid) =>
  usingGet(`/assessments/details/sas/${assessmentId}`, { useProxy: true })

export const uploadAssessmentDocument = (activityId: Guid, files: File[]) => {
  const { login: userId } = UserUtils.getUserAccountInfo()
  const input = {
    activityId,
    userId,
  }
  const formData = new FormData()
  formData.append('BinaryMetadata', JSON.stringify(input))
  formData.append('BinaryData', files[0])
  return usingUpload('Assessments/UploadAssessmentDocument', formData)
}

export const removeAssessmentDocument = (documentId: Guid) =>
  usingDelete(`Assessments/RemoveAssessmentDocument/${documentId}`)

export const performSelfAssessment = (values: SelfAssessmentParams, activityId: Guid) => {
  const { assess, comment } = values
  const isApproved = assess === AssessStatus.Approved
  return usingPost('Assessments/PerformSelfAssessment', { activityId, comment, isApproved })
}

export const createDocumentDownloadUrl = (documentId: Guid) => {
  const sessionToken = SessionUtils.getSessionToken() || ''
  return createProxyUrl(`assessments/getDocument?token=${sessionToken}&documentId=${documentId}`)
}
